<template>
    <div class="card h-100">
        <div class="card-header py-3">
            <h4>Boeking laden</h4>
        </div>
        <div class="card-body overflow-x-hidden overflow-y-auto text-center">
            <span class="spinner-border spinner-border text-primary m-5"></span>
        </div>
    </div>
</template>

<script setup>
const bookingStore = useBookingStore()

// Get product key from route params
const route = useRoute()
const productKey = route.params.key

if (import.meta.client) {
    // Load product data
    await bookingStore.getProduct(productKey)

    // Check if the product is loaded
    if (!bookingStore.product) {
        // Redirect to homepage if product is not found
        navigateTo('https://helikopter-vlucht.net/', { external: true })
    }

    // Redirect to booking page if product is loaded
    navigateTo(`/booking/preferences`)
}
</script>
